import { render, staticRenderFns } from "./OrgBranding.vue?vue&type=template&id=215ed1c8&scoped=true&"
import script from "./OrgBranding.vue?vue&type=script&lang=js&"
export * from "./OrgBranding.vue?vue&type=script&lang=js&"
import style0 from "./OrgBranding.vue?vue&type=style&index=0&id=215ed1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ed1c8",
  null
  
)

export default component.exports